const _excluded = ["children", "position", "theme", "transition"],
  _excluded2 = ["type", "message", "notificationId", "transition"],
  _excluded3 = ["transition"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { PositionNotification, ThemeNotification, TransitionNotification, TypeNotification, getTransitionAnimation } from "./notification-toastify.vm";
import { NotificationToastifyContext } from "./notification-toastify.context";
import { nanoid } from 'nanoid';
import 'react-toastify/dist/ReactToastify.css';
export const NotificationToastifyProvider = props => {
  const {
      children,
      position,
      theme,
      transition
    } = props,
    args = _objectWithoutProperties(props, _excluded);
  const transitionAnimation = getTransitionAnimation(transition);
  const [notificationIds, setNotificationIds] = React.useState([]);
  const addNotifications = React.useCallback(props => {
    if (props && props.length > 0) {
      props.forEach(not => {
        const {
            type,
            message,
            notificationId,
            transition
          } = not,
          args = _objectWithoutProperties(not, _excluded2);
        const toastId = notificationId ? notificationId : `notification-${nanoid(3)}`;
        const transitionAnimation = getTransitionAnimation(transition);
        if (!type || type === TypeNotification.DEFAULT) {
          toast(message, _objectSpread(_objectSpread({}, args), {}, {
            toastId: toastId,
            updateId: toastId,
            transition: transitionAnimation
          }));
        } else if (type === TypeNotification.SUCCESS) {
          toast.success(message, _objectSpread(_objectSpread({}, args), {}, {
            toastId: toastId,
            updateId: toastId,
            transition: transitionAnimation
          }));
        } else if (type === TypeNotification.ERROR) {
          toast.error(message, _objectSpread(_objectSpread({}, args), {}, {
            toastId: toastId,
            updateId: toastId,
            transition: transitionAnimation
          }));
        } else if (type === TypeNotification.INFO) {
          toast.info(message, _objectSpread(_objectSpread({}, args), {}, {
            toastId: toastId,
            updateId: toastId,
            transition: transitionAnimation
          }));
        } else if (type === TypeNotification.WARNING) {
          toast.warning(message, _objectSpread(_objectSpread({}, args), {}, {
            toastId: toastId,
            updateId: toastId,
            transition: transitionAnimation
          }));
        }
        setNotificationIds(notifi => [...notifi, toastId]);
        toast.onChange(t => {
          if (t.status === 'removed') {
            setNotificationIds(notifi => notifi.filter(n => n !== t.id));
          }
        });
      });
    } else {
      toast.error('🔥CONFIGURA LA NOTIFICACION', {
        theme: 'colored'
      });
    }
  }, [transition]);
  const removeNotifications = React.useCallback(props => {
    if (props && props.length > 0) {
      props.forEach(p => {
        toast.update(p, {
          autoClose: 1
        });
      });
    }
  }, []);
  const updateNotifications = React.useCallback(props => {
    if (props && props.length > 0) {
      props.forEach(p => {
        const {
          notificationId,
          values
        } = p;
        const {
            transition
          } = values,
          rest = _objectWithoutProperties(values, _excluded3);
        const transitionAnimation = getTransitionAnimation(transition);
        toast.update(notificationId, _objectSpread({
          transition: transitionAnimation
        }, rest));
      });
    }
  }, []);
  const addPromiseNotifications = React.useCallback(props => {
    if (props && props.length > 0) {
      const promises = [];
      props.forEach(promiseNotification => {
        const {
          promise,
          promiseState,
          options
        } = promiseNotification;
        const transitionAnimation = getTransitionAnimation(options === null || options === void 0 ? void 0 : options.transition);
        promises.push(toast.promise(promise, {
          success: promiseState.success,
          pending: promiseState.pending,
          error: promiseState.error
        }, _objectSpread(_objectSpread({}, options), {}, {
          transition: transitionAnimation
        })));
      });
      return promises;
    }
    return null;
  }, []);
  return /*#__PURE__*/React.createElement(NotificationToastifyContext.Provider, {
    value: {
      addNotifications,
      addPromiseNotifications,
      removeNotifications,
      updateNotifications,
      notificationIds
    }
  }, /*#__PURE__*/React.createElement(ToastContainer, _extends({
    position: position,
    theme: theme,
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    transition: transitionAnimation
  }, args)), children);
};
NotificationToastifyProvider.defaultProps = {
  position: PositionNotification.BOTTOM_RIGHT,
  theme: ThemeNotification.LIGHT,
  transition: TransitionNotification.BOUNCE
};